export const loading = "loading";
export const succeeded = "succeeded";
export const failed = "failed";

export const timezoneOptions = [
  { label: "Newfoundland Time (NST)", value: "America/St_Johns" },
  { label: "Atlantic Time (AST)", value: "America/Halifax" },
  { label: "Eastern Time (EST)", value: "America/Toronto" },
  { label: "Central Time (CST)", value: "America/Winnipeg" },
  { label: "Mountain Time (MST)", value: "America/Edmonton" },
  { label: "Pacific Time (PST)", value: "America/Vancouver" },
];

export const getTimezoneLabel = (ianaValue) => {
  const option = timezoneOptions.find((tz) => tz.value === ianaValue);
  return option ? option.label : ianaValue;
};

export const EVENT_URL_PATTERN = /^https?:\/\/\S+$/i;
export const EVENT_URL_ERROR_MESSAGE =
  "Must start with http:// or https:// and contain no spaces";
export const isValidEventUrl = (value) =>
  !value || EVENT_URL_PATTERN.test(value);
